import { useSelector } from 'react-redux';
import { get } from 'lodash';
import s from '../AssuranceLines.module.css';

export interface SecondLineActionItemProps {
  type: string;
}

const SecondLineActionItemComponent = ({ type }: SecondLineActionItemProps) => {
  const CAPAction = useSelector((state) =>
    get(state, 'risk.myAssuranceInfo.result.assuranceCorrectiveActionPlan', [])
  );

  const assuranceProgramAction = useSelector((state) =>
    get(state, 'risk.myAssuranceInfo.result.assuranceProgram', [])
  );

  if (type === 'CAP') {
    return (
      <div className={s.SLAActionItemsSection}>
        <div className={`${s.SLAActionItems}`}>
          <div className={`${s.actionItem} ${s.overdue}`}>
            <div className={s.bar}></div>
            <div>
              <p>Overdue</p>
              <span>{CAPAction?.overdueAction}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.notAssigned}`}>
            <div className={s.bar}></div>
            <div>
              <p>Not Assigned</p>
              <span>{CAPAction?.notAssignedAction}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.inProgress}`}>
            <div className={s.bar}></div>
            <div>
              <p>In Progress</p>
              <span>{CAPAction?.inProgressAction}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.closed}`}>
            <div className={s.bar}></div>
            <div>
              <p>Closed</p>
              <span>{CAPAction?.closedAction}</span>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={s.SLAActionItemsSection}>
        <div className={`${s.SLAActionItems}`}>
          <div className={`${s.actionItem} ${s.planned}`}>
            <div className={s.bar}></div>
            <div>
              <p>Planned</p>
              <span>{assuranceProgramAction?.plannedProgram}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.conducted}`}>
            <div className={s.bar}></div>
            <div>
              <p>Conducted</p>
              <span>{assuranceProgramAction?.conductedProgram}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.cancelled}`}>
            <div className={s.bar}></div>
            <div>
              <p>Cancelled</p>
              <span>{assuranceProgramAction?.cancelledProgram}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.overdue}`}>
            <div className={s.bar}></div>
            <div>
              <p>Deferred</p>
              <span>{assuranceProgramAction?.deferredProgram}</span>
            </div>
          </div>
          <div className={`${s.actionItem} ${s.unplanned}`}>
            <div className={s.bar}></div>
            <div>
              <p>Unplanned</p>
              <span>{assuranceProgramAction?.unplannedProgram}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default SecondLineActionItemComponent;